import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Module {
  id: string;
  title_i18n: Record<string, string>;
  description_i18n: Record<string, string>;
  icon: string;
  entry_route: string;
  required_personas: string[];
  enabled: boolean;
  last_used_at?: string;
  is_favourite?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModulesService {
  private http = inject(HttpClient);

  list(): Observable<{ modules: Module[] }> {
    return this.http.get<{ modules: Module[] }>(`${environment.apiBaseUrl}/v1/portal/modules`);
  }
}
